var ngModule;
try {
  ngModule = angular.module('templates');
} catch (e) {
  ngModule = angular.module('templates', []);
}

ngModule.run(['$templateCache', function ($templateCache) {
  $templateCache.put('/app/search/directives/search-results/search-results.html',
    '<div class="search-results">\n' +
    '    <div class="search-result-row" ng-repeat="item in items" ng-switch="item.elastica_type">\n' +
    '        <div class="search-result row" ng-switch-when="news" search-result-news></div>\n' +
    '        <div class="search-result row" ng-switch-when="event" search-result-event></div>\n' +
    '        <div class="search-result row" ng-switch-when="post" search-result-post></div>\n' +
    '        <div class="search-result row" ng-switch-when="page" search-result-page></div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '\n' +
    '<div class="search-results-show-more" ng-show="hasNextResult()">\n' +
    '    <button class="btn-show btn-show_hover search-results-show-more-btn" ng-click="showMore()">Показать ещё</button>\n' +
    '</div>\n' +
    '');
}]);

module.exports = "/app/search/directives/search-results/search-results.html";